import { render } from "./TemplatePicker.vue?vue&type=template&id=29389868&scoped=true"
import script from "./TemplatePicker.vue?vue&type=script&lang=js"
export * from "./TemplatePicker.vue?vue&type=script&lang=js"

import "./TemplatePicker.vue?vue&type=style&index=0&id=29389868&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29389868"]])

export default __exports__